import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { individualsService, Individual, CreateInvidualRequest } from '@aslanpay/portal-common-lib';

const useCreateEmployee = ({
  onSuccess,
  onError,
}: UseMutationOptions<Individual, Error, CreateInvidualRequest>) => {
  return useMutation<Individual, Error, CreateInvidualRequest>(
    ({
      firstName,
      lastName,
      email,
      additionalEmail,
      payCalendarId,
      startDate,
      externalPayrollId,
      annualGrossSalary,
      salaried,
      role,
      invite,
      companyId,
      previousIndividualId,
    }: CreateInvidualRequest) =>
      individualsService.createIndividual({
        firstName,
        lastName,
        email: email.toLowerCase(),
        additionalEmail: additionalEmail?.toLowerCase(),
        payCalendarId,
        startDate,
        externalPayrollId,
        annualGrossSalary,
        salaried,
        role,
        invite,
        companyId,
        previousIndividualId,
      }),
    { onSuccess, onError }
  );
};

export default useCreateEmployee;
